export const loginToServerConfig = async (Username: string, Password: string, langCode: string) => {
    const body = JSON.stringify({
        Username,
        Password,
        ReturnUrl: '/ServerConfig',
    });

    await fetch('/Auth/Login', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Content-Length': body.length.toString(),
        },
        credentials: 'same-origin',
        body,
    });

    window.location.href = `/ServerConfig?lang=${langCode}`;
};

export const launchServerConfig = async (joinSession: boolean, langCode: string) => {
    const w = window.open('', '_blank');

    if (joinSession) {
        await fetch('/Auth/Login', {
            method: 'POST',
            headers: {
                'UseWebClientCookie': '1',
            },
            credentials: 'same-origin',
        });
    }
    
    if (w) {
        w.location.href = `/ServerConfig?lang=${langCode}`;
        w.focus();
    }
};



// WEBPACK FOOTER //
// ./src/logic/externalServices/serverConfig.ts